'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProductsCarousel = exports.CAROUSEL_SELECTOR = exports.CONTAINER_SELECTOR = undefined;

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _CarouselSection2 = require('./../../sections/carousel/CarouselSection');

var _ShopifySection = require('./../../sections/ShopifySection');

var _Responsive = require('./../../settings/Responsive');

var ResponsiveSizes = _interopRequireWildcard(_Responsive);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CONTAINER_SELECTOR = exports.CONTAINER_SELECTOR = '[data-products-carousel]'; /*
                                                                                   *  Products Carousel
                                                                                   *    Scripts for the Products Carousel section.
                                                                                   *    Product thumbs in a slick slide
                                                                                   *
                                                                                   *  Version:
                                                                                   *    1.0.0 - 2020/05/17
                                                                                   */

var CAROUSEL_SELECTOR = exports.CAROUSEL_SELECTOR = '[data-products-carousel-carousel]';

var ProductsCarousel = exports.ProductsCarousel = function (_CarouselSection) {
  (0, _inherits3.default)(ProductsCarousel, _CarouselSection);

  function ProductsCarousel(container) {
    (0, _classCallCheck3.default)(this, ProductsCarousel);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ProductsCarousel.__proto__ || Object.getPrototypeOf(ProductsCarousel)).call(this, container));

    _this.carouselContainer = container.find(CAROUSEL_SELECTOR);
    _this.slick = _this.initCarousel(_this.carouselContainer);
    return _this;
  }

  (0, _createClass3.default)(ProductsCarousel, [{
    key: 'optionOverrides',
    value: function optionOverrides() {
      return {
        infinite: this.container.data('infinite') === true ? true : false,
        autoplay: this.container.data('autoplay') == true,
        autoplaySpeed: this.container.data('autoplay-speed') * 1000 || 5000,
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: false,
        arrows: true,
        nextArrow: this.container.find(_CarouselSection2.NEXT_SELECTOR),
        prevArrow: this.container.find(_CarouselSection2.PREV_SELECTOR),
        adaptiveHeight: true,
        responsive: [{
          breakpoint: ResponsiveSizes.small - 1,
          settings: {
            slidesToShow: 2
          }
        }, {
          breakpoint: ResponsiveSizes.medium - 1,
          settings: {
            slidesToShow: 3,
            arrows: true,
            nextArrow: this.container.find(_CarouselSection2.NEXT_SELECTOR)
          }
        }]
      };
    }
  }]);
  return ProductsCarousel;
}(_CarouselSection2.CarouselSection);

(0, _ShopifySection.register)(CONTAINER_SELECTOR, ProductsCarousel);